
import { Component, Vue } from 'vue-property-decorator'
import SellerHeader from '@/components/Seller/SellerHeader.vue'
import { ErrorMessages } from '@/helpers/constants'
import { getVenue, updateVenue, createVenue } from '@/services/venues.service'
import { VenueAdmin } from '@/interfaces/admin/venues/venue-admin.interface'

@Component({
  components: {
    SellerHeader,
  },
})
export default class VenueForm extends Vue {
  venue: VenueAdmin = {} as VenueAdmin
  venueId!: number
  title = 'Crear Venue'

  statusOptions = [
    { value: true, text: 'Activo' },
    { value: false, text: 'Inactivo' },
  ]

  mapsUrlRule = (val: string | undefined) => {
    if (!val) return true
    const ok = /^(https?:\/\/).+/i.test(val.trim())
    return ok || 'Debe ser una URL válida (http/https)'
  }

  get isDisabled(): boolean {
    return !this.venue.name || this.venue.status === null || this.venue.status === undefined
  }

  async fetchVenue(venueId: number) {
    try {
      const venue = await getVenue(venueId)
      this.venue = venue
    } catch (error) {
      Vue.$toast.error(ErrorMessages.COMMON)
    }
  }

  async submit() {
    try {
      if (this.venue.maps_url) this.venue.maps_url = this.venue.maps_url.trim()
      const isUpdate = Boolean(this.venue.id)
      if (isUpdate) {
        await updateVenue(this.venue)
        Vue.$toast.success('Venue actualizado')
      } else {
        await createVenue(this.venue)
        Vue.$toast.success('Venue creado')
      }
      this.$router.push('/seller/administration/venue-list')
    } catch (error) {
      Vue.$toast.error(ErrorMessages.COMMON)
    }
  }

  mounted() {
    if (this.$route.params.id) {
      this.title = 'Editar Venue'
      this.venueId = parseInt(this.$route.params.id as string)
      this.fetchVenue(this.venueId)
    }
  }
}
